// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AdminApprovalsPage.responsive.css
   Responsive Stylesheet for User Verification & Role Approvals
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .admin-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .admin-page-header {
    flex-wrap: wrap !important;
    gap: 14px !important;
  }

  .admin-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 16px 0 !important;
  }

  .admin-filter-card {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .admin-table-card {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 14px !important;
  }

  .admin-table {
    min-width: 720px !important;
  }

  .admin-modal.large {
    width: min(92vw, 640px) !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .admin-page {
    padding: 10px 10px 30px !important;
  }

  .admin-page-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }

  .admin-page-header h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .admin-page-header p {
    font-size: 13px !important;
  }

  .admin-primary-btn {
    width: 100% !important;
    min-height: 42px !important;
    font-size: 13px !important;
  }

  /* Stats grid */
  .admin-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 12px 0 !important;
  }

  .admin-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .admin-stat-card strong {
    font-size: 18px !important;
  }

  .admin-stat-card span {
    font-size: 10px !important;
  }

  /* Filters */
  .admin-filter-card {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
    padding: 14px !important;
  }

  .admin-filter-card input,
  .admin-filter-card select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  /* Responsive Table */
  .admin-table-card {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 14px !important;
    margin-top: 14px !important;
  }

  .admin-table {
    min-width: 680px !important;
  }

  .admin-table th,
  .admin-table td {
    padding: 10px 12px !important;
    font-size: 12px !important;
  }

  .admin-actions {
    display: flex !important;
    gap: 6px !important;
    flex-wrap: nowrap !important;
  }

  .admin-actions button {
    padding: 5px 9px !important;
    font-size: 11px !important;
  }

  /* Pagination */
  .admin-pagination {
    flex-wrap: wrap !important;
    gap: 8px !important;
    justify-content: center !important;
    margin-top: 14px !important;
  }

  .admin-pagination button {
    min-height: 38px !important;
    padding: 6px 14px !important;
  }

  /* Modals on phone */
  .admin-modal,
  .admin-modal.large {
    width: 95vw !important;
    max-height: 94vh !important;
    padding: 16px 14px !important;
    border-radius: 14px !important;
  }

  .admin-details-grid,
  .admin-form-grid {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }

  .admin-modal-actions {
    flex-direction: column !important;
    gap: 8px !important;
  }

  .admin-modal-actions button {
    width: 100% !important;
    min-height: 40px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminApprovalsPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,YAAY;EACZ;IACE,qCAAqC;IACrC,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,qBAAqB;EACrB;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,eAAe;EACf;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,oBAAoB;EACpB;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================================================\n   AdminApprovalsPage.responsive.css\n   Responsive Stylesheet for User Verification & Role Approvals\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .admin-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .admin-page-header {\n    flex-wrap: wrap !important;\n    gap: 14px !important;\n  }\n\n  .admin-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 16px 0 !important;\n  }\n\n  .admin-filter-card {\n    display: grid !important;\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n  }\n\n  .admin-table-card {\n    width: 100% !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    border-radius: 14px !important;\n  }\n\n  .admin-table {\n    min-width: 720px !important;\n  }\n\n  .admin-modal.large {\n    width: min(92vw, 640px) !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .admin-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .admin-page-header {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 12px !important;\n  }\n\n  .admin-page-header h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .admin-page-header p {\n    font-size: 13px !important;\n  }\n\n  .admin-primary-btn {\n    width: 100% !important;\n    min-height: 42px !important;\n    font-size: 13px !important;\n  }\n\n  /* Stats grid */\n  .admin-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 12px 0 !important;\n  }\n\n  .admin-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .admin-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .admin-stat-card span {\n    font-size: 10px !important;\n  }\n\n  /* Filters */\n  .admin-filter-card {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n    padding: 14px !important;\n  }\n\n  .admin-filter-card input,\n  .admin-filter-card select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  /* Responsive Table */\n  .admin-table-card {\n    width: 100% !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    border-radius: 14px !important;\n    margin-top: 14px !important;\n  }\n\n  .admin-table {\n    min-width: 680px !important;\n  }\n\n  .admin-table th,\n  .admin-table td {\n    padding: 10px 12px !important;\n    font-size: 12px !important;\n  }\n\n  .admin-actions {\n    display: flex !important;\n    gap: 6px !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .admin-actions button {\n    padding: 5px 9px !important;\n    font-size: 11px !important;\n  }\n\n  /* Pagination */\n  .admin-pagination {\n    flex-wrap: wrap !important;\n    gap: 8px !important;\n    justify-content: center !important;\n    margin-top: 14px !important;\n  }\n\n  .admin-pagination button {\n    min-height: 38px !important;\n    padding: 6px 14px !important;\n  }\n\n  /* Modals on phone */\n  .admin-modal,\n  .admin-modal.large {\n    width: 95vw !important;\n    max-height: 94vh !important;\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .admin-details-grid,\n  .admin-form-grid {\n    grid-template-columns: 1fr !important;\n    gap: 10px !important;\n  }\n\n  .admin-modal-actions {\n    flex-direction: column !important;\n    gap: 8px !important;\n  }\n\n  .admin-modal-actions button {\n    width: 100% !important;\n    min-height: 40px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
